const accountDetails = {
  accountDetails: {
    managePreferences: 'Einstellungen ändern',
    email: 'E-Mail',
    emailChangeText: 'Sie müssen die Änderung Ihrer E-Mail-Adresse noch bestätigen!',
    confirmationText: 'Wir haben eine Bestätigungs-E-Mail an %{email} gesendet. Sie müssen auf den Link in dieser Nachricht klicken, damit die Änderung der E-Mail-Adresse wirksam wird.',
    resendConfirmationEmail: 'Bestätigungs-E-Mail erneut senden',
    cancelChange: 'Diese Änderung abbrechen',
    firstName: 'Vorname',
    lastName: 'Nachname',
    phone: 'Telefon',
    company: 'Firmenname',
    saveDetails: 'Kontodetails speichern',
    changeEmailRequest: 'E-Mail ändern',
    job_profile: {
      label: "Wählen Sie das Stellenprofil der Person im Unternehmen",
      tooltip_msg: 'Wählen Sie das primäre Jobprofil der Person aus. Wenn der Benutzer mehr als eine primäre Rolle hat, wählen Sie "Andere" aus.'
    }
  },
  resetPassword: {
    instructions: 'Ihr Kennwort muss mindestens sechs Zeichen lang sein, mindestens eine Ziffer oder ein Sonderzeichen enthalten und darf nicht mit Ihrer E-Mail-Adresse identisch sein.',
    currentPassword: 'Aktuelles Kennwort',
    newPassword: 'Neues Kennwort eingeben',
    confirmNewPassword: 'Neues Kennwort bestätigen',
  }
};

export default accountDetails;